import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { getApiBaseUrl } from "../api/utils";

export function LoginScreen({ onNavigateToSignup, fromURL, mode }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login } = useAuth();

  const API_URL = getApiBaseUrl();

  const handleLogin = async () => {
    setLoading(true);
    setError("");

    // This can be a separate function, a custom hook, or part of a component.
// const login = async (data) => {
//     // Construct the URL-encoded body using URLSearchParams
    const body = new URLSearchParams();
    body.set('username', username);
    body.set('password', password);
  
    const headers = {
      'accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'ngrok-skip-browser-warning': '69420',
    };
  
    try {
      const response = await fetch(`${API_URL}/users/login/`, {
        method: 'POST',
        headers: headers,
        body: body.toString(),
      });
  
      if (!response.ok) {
        // Handle HTTP errors, e.g., 401 Unauthorized, 422 Unprocessable Content
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const result = await response.json();
      if (!result?.access_token) {
        throw new Error("Login failed");
      }
      await login(result.access_token);
      navigate(fromURL, {state: {mode: mode}});
      return result;

    } catch (error) {
      // Handle network errors or other exceptions
      console.error('Login failed:', error);
      setError("Invalid login details. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div className="p-6 max-w-sm mx-auto">
      <h2 className="text-2xl font-semibold mb-4">Login</h2>

      <input
        type="text"
        placeholder="Email or phone"
        className="border p-2 w-full mb-3"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        className="border p-2 w-full mb-3"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

      <button
        onClick={handleLogin}
        disabled={loading}
        className="bg-blue-600 text-white px-4 py-2 w-full rounded"
      >
        {loading ? "Logging in..." : "Login"}
      </button>

      <p className="mt-4 text-center text-sm">
        Don’t have an account?{" "}
        <button
          className="text-blue-600 underline"
          onClick={onNavigateToSignup}
        >
          Sign up
        </button>
      </p>
    </div>
  );
}
